import { RESET_STORE } from '../actionTypes';

export * as conversationAction from './conversation';
export * as documentAction from './document';
export * as homeAction from './home';
export * as modelAction from './model';
export * as synchronizationAction from './synchronization';
export * as taskAction from './task';
export * as translationAction from './translation';
export * as uploadAction from './upload';
export * as userManageAction from './userManage';

export const resetStore = () => ({ type: RESET_STORE });
